import {
  FETCH_AUTH,
  FETCH_AUTH_SUCCESS,
  FETCH_AUTH_FAIL,
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  SET_FIRESTORE_USER,
  SET_STRIPE_DATA,
  REMOVE_FIRESTORE_USER,
} from "../config/constant";

const initialState = {
  isAuth: false,
  users: [],
  fetchingUser: false,
  fetchingAuth: false,
  error: false,
  authType: "admin",
};

export default function dataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AUTH:
      return {
        ...state,
        isAuth: false,
        fetchingAuth: true,
      };
    case FETCH_AUTH_SUCCESS:
      return {
        ...state,
        isAuth: action.isAuth,
        fetchingAuth: false,
        authType: action.authType || "admin",
      };
    case FETCH_AUTH_FAIL:
      return {
        ...state,
        fetchingAuth: false,
        error: true,
      };
    case FETCH_USER:
      return {
        ...state,
        users: [],
        fetchingUser: true,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        fetchingUser: false,
        firestoreUser: action.firestoreUser ?? state.firestoreUser,
        users: action.users ?? [],
      };
    case FETCH_USER_FAIL:
      return {
        ...state,
        fetchingUser: false,
        error: true,
      };
    case SET_FIRESTORE_USER:
      return {
        ...state,
        firestoreUser: action.firestoreUser ?? state.firestoreUser,
      };
    case REMOVE_FIRESTORE_USER:
      return {
        ...state,
        firestoreUser: undefined,
      };
    case SET_STRIPE_DATA:
      return {
        ...state,
        stripeData: action.stripeData,
      };
    default:
      return state;
  }
}
